/**
 * Barrel de compatibilidade: reexporta o client único de `@/api/turbopro`
 * mantendo os nomes que os ~44 arquivos `*Api.ts` já importavam, para que a
 * migração de cada um seja só trocar o path (ver `@/api/turbopro` e o plano
 * de migração). `apiIC`/`apiEmalote` não existem mais como bases distintas —
 * os dois hosts (`api.impostocerto.com.br/ImpostoCerto/api` e
 * `.../ICEmaloteWeb`) viraram uma única base — ver `@/api/base.ts` pra URL
 * atual (o host oficial `api.turbopro.com.br` ainda não existe no DNS).
 */
export { api } from '@/api/turbopro';
import { sessao } from '@/auth/session-store';

/** CNPJ do gestor selecionado — usado como header manual pelos endpoints legados que ainda o exigem (ex.: `Arq/*`, `uploads/*`). A identidade "de verdade" já vem no JWT via `Auth/SelecionarGestor`. */
export function getCnpjGestor(): string {
  return sessao().cnpjGestor || '00000000000000';
}

/** E-mail do usuário logado — mesmo racional de `getCnpjGestor()`, para os poucos endpoints legados que ainda pedem `email_login` manual. */
export function getEmailLogin(): string {
  return sessao().email || '';
}
